import { type Alignment } from '../../../__generated__/graphql-client-types';
import { VALID_ALIGNMENTS } from '../../../constants/home/general';

const isAlignment = (value?: string): value is Alignment => Boolean(value && VALID_ALIGNMENTS.has(value));

export const convertToSplashAlignment = (value: string | undefined): Alignment => {
	const formatted = value?.toUpperCase().replace('-', '_');
	return isAlignment(formatted) ? formatted : 'CENTER';
};

export const convertToSplashButtonStyle = (value: string | undefined): 'PRIMARY' | 'SECONDARY' => {
	return value?.toUpperCase() === 'PRIMARY' ? 'PRIMARY' : 'SECONDARY';
};

export const convertToSplashCTAStyle = (value: string | undefined): 'LIGHT' | 'DARK' => {
	return value?.toUpperCase() === 'LIGHT' ? 'LIGHT' : 'DARK';
};
